import type { MemberAttribute } from "@di-devs/member-feature-plugin/shared";
import { useBetterFeatureClient } from "@di-devs/utils-fe";
import { Button, Modal, message } from "antd";
import { motion } from "framer-motion";
import { useEffect, useMemo, useState } from "react";
import { TapAnimationComponent } from "@/components";
import type { FeatureClient } from "@/config/client";
import {
	useListMemberAttributes,
	useUpdateMemberAttributesOrder,
} from "@/queries";
import { COMMONS } from "@/utils";
import MemberAttributeDndOrder from "./components/MemberAttributeDndOrder";

interface Props {
	publicSettings: any; // TODO: Use proper type
	isMemberAttributeOrderModal: boolean;
	hideMemberAttributeOrderModal: () => void;
}

const MemberAttributeOrderModal = (props: Props) => {
	const {
		publicSettings,
		isMemberAttributeOrderModal,
		hideMemberAttributeOrderModal,
	} = props;

	const [memberAttributesOrder, setMemberAttributesOrder] = useState<
		MemberAttribute[]
	>([]);

	const reactFeatureClient = useBetterFeatureClient<FeatureClient>();
	const { data } = useListMemberAttributes(reactFeatureClient, {
		enabled: isMemberAttributeOrderModal,
	});
	const memberAttributes: MemberAttribute[] = useMemo(
		() => data?.data?.data || [],
		[data?.data?.data],
	);

	const updateMemberAttributeOrder =
		useUpdateMemberAttributesOrder(reactFeatureClient);

	useEffect(() => {
		const memberAttributeNewOrder =
			COMMONS.groupMemberAttributeAddress(memberAttributes);
		setMemberAttributesOrder(memberAttributeNewOrder);
	}, [memberAttributes]);

	const handleMemberAttributeOrderUpdate = () => {
		// Check if the member attribute order is changed
		if (
			JSON.stringify(memberAttributesOrder) === JSON.stringify(memberAttributes)
		) {
			message.success(COMMONS.SUCCESS_UPDATE_MSG);
		} else {
			updateMemberAttributeOrder.mutate({
				memberAttributes: memberAttributesOrder.map((q, i) => ({
					memberAttributeId: q?.memberAttributeId as number,
					showOrder: i,
				})),
			});
		}
		hideMemberAttributeOrderModal();
	};

	const undoMemberAttributeOrderChanges = () => {
		const memberAttributeNewOrder =
			COMMONS.groupMemberAttributeAddress(memberAttributes);
		setMemberAttributesOrder(memberAttributeNewOrder);
	};

	return (
		<Modal
			open={isMemberAttributeOrderModal}
			onCancel={hideMemberAttributeOrderModal}
			title="質問表示順"
			footer={null}
			destroyOnClose
			maskClosable={false}
			centered
			width={720}
			styles={{
				body: {
					maxHeight: "90vh",
					overflowY: "auto",
					overflowX: "hidden",
				},
			}}
		>
			<motion.div
				variants={COMMONS.ANIMATION_VARIANT_STAGGER_CONTAINER}
				initial="hidden"
				animate="show"
				exit="hidden"
			>
				<motion.div
					variants={COMMONS.ANIMATION_VARIANT_STAGGER_ITEM}
					className="flex justify-end mb-4"
				>
					<TapAnimationComponent>
						<Button
							className="m-1"
							size="large"
							danger
							onClick={undoMemberAttributeOrderChanges}
						>
							元に戻す
						</Button>
					</TapAnimationComponent>
					<TapAnimationComponent>
						<Button
							type="primary"
							className="m-1 w-32"
							size="large"
							onClick={handleMemberAttributeOrderUpdate}
						>
							保存
						</Button>
					</TapAnimationComponent>
				</motion.div>
				<motion.div
					variants={COMMONS.ANIMATION_VARIANT_STAGGER_ITEM}
					className="flex justify-center rounded mb-8 p-4"
					style={{
						color: publicSettings?.PRIMARY_COLOR?.valueString,
						backgroundColor: publicSettings?.PRIMARY_LIGHT_COLOR.valueString,
					}}
				>
					<p>質問を上下にドラッグして並べ替えます</p>
				</motion.div>
			</motion.div>
			<MemberAttributeDndOrder
				memberAttributesOrder={memberAttributesOrder}
				setMemberAttributesOrder={setMemberAttributesOrder}
			/>
		</Modal>
	);
};

export default MemberAttributeOrderModal;
